import { cssVars } from '@cast/design-system';

const horizontalPadding = '24px';

export const mainLayoutCssVars = cssVars({
  contentWidth: undefined,
  horizontalPadding,
  negativeHorizontalPadding: `-${horizontalPadding}`,
});
